import { render, staticRenderFns } from "./OzDrawerModal.vue?vue&type=template&id=470ada3e&scoped=true&"
import script from "./OzDrawerModal.vue?vue&type=script&lang=ts&"
export * from "./OzDrawerModal.vue?vue&type=script&lang=ts&"
import style0 from "./OzDrawerModal.vue?vue&type=style&index=0&id=470ada3e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ada3e",
  null
  
)

export default component.exports